const errors = {
  generic: 'Operation could not be completed',
  required: 'This is a required input',
};

export default errors;
